import { MenuItem, VueRouter } from "@abaco/web-common/src/app";

export function createMenu(router: VueRouter): MenuItem[] {
    return [
        {
            id: "assets-home",
            descrKey: "assets-home",
            icon: "abc-icon abc-icon-box",
            onClick: () => {return},
            get isVisible() {
                return true;
            },
            isOpen: true,
            children: [
                {
                    id: "assets-workers",
                    descrKey: "workers",
                    icon: "fal fa-user-hard-hat",
                    onClick: () => router.push({ name: "workers" }),
                    get isVisible() {
                        return true;
                    }
                },
                {
                    id: "assets-materials",
                    descrKey: "materials",
                    icon: "abc-icon abc-icon-box",
                    onClick: () => router.push({ name: "materials" }),
                    get isVisible() {
                        return true;
                    }
                },
                {
                    id: "assets-machines",
                    descrKey: "machines",
                    icon: "abc-icon abc-icon-autonomous-driving-vehicle",
                    onClick: () => router.push({ name: "equipments" }),
                    get isVisible() {
                        return true;
                    }
                },
                {
                    id: "assets-buildings",
                    descrKey: "assets-buildings",
                    icon: "abc-icon abc-icon-home-2",
                    onClick: () => router.push({ name: "buildings" }),
                    get isVisible() {
                        return true;
                    }
                },
                {
                    id: "assets-administration",
                    descrKey: "assets-administration",
                    icon: "fal fa-users-cog",
                    onClick: () => router.push({ name: "assets-administration" }),
                    get isVisible() {
                        return true;
                    }
                }
            ]
        }
    ];
}

